<!--
 * @Author: p_fy
 * @Date: 2019-07-17 13:47:49
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-29 18:13:07
 * @Description: 石化云仓-普仓需求列表以及详情信息。
 -->
<template>
  <div ref="el" v-loading="viewControl.loading" class="demand-items-container">

    <template v-if="!viewControl.loading && data.length < 1">
      <div class="demand-item-container no-data-info">
        <font>暂无匹配数据</font>
      </div>
    </template>
    <template v-for="(demand, index) of data">
      <div :key="index" class="demand-item-container">
        <div class="demand-item-card">
          <div v-viewer class="demand-item-picture">
            <template v-if="cargoUrl(demand)[0]">
              <el-image :src="cargoUrl(demand)[0] | getImg" lazy onerror="this.src='https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1603344840505&di=e55771d373e94d0a3299e1146818468b&imgtype=0&src=http%3A%2F%2F2e.zol-img.com.cn%2Fproduct%2F135%2F962%2FcerYTKTl41Vbs.jpg';this.onerror=null;" />
            </template>
            <template v-else>
              <el-image :src="require('@/assets/img/default_img.png')" lazy onerror="this.src='https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1603344840505&di=e55771d373e94d0a3299e1146818468b&imgtype=0&src=http%3A%2F%2F2e.zol-img.com.cn%2Fproduct%2F135%2F962%2FcerYTKTl41Vbs.jpg';this.onerror=null;" />
            </template>
          </div>
          <div class="demand-item-content">
            <div class="content-left" style="">
              <div class="title">
                <span class="demand-demandName">
                  {{ demand.demandName }}
                </span>
                <el-tag type="danger">普通仓库</el-tag>
              </div>
              <div>
                <span>仓库位置：</span>
                <span>{{ demand.storageLocationLabel }}</span>
              </div>
              <div>
                <span>货物类型：</span>
                <span>{{ demand.storageTypeLabel }}</span>
                <el-divider direction="vertical" />
                <span>需求面积：{{ demand.demandArea }}㎡</span>
              </div>
              <div>
                <span>公司名称：</span>
                <span>{{ demand.companyName }}</span>
                <el-divider direction="vertical" />
                <span>联系人：{{ demand.linkMan }}</span>
              </div>
              <div class="remarksCls">
                <span>备注说明：</span>
                <span :title="demand.remarks">{{ demand.remarks }}</span>
              </div>
            </div>
            <div class="content-middle">
              <div>期望租金</div>
              <div class="one">
                <strong>¥{{ demand.expectPrice }}元/m²/天</strong>
              </div>
              <div class="two">预租日期</div>
              <div class="there">{{ demand.leaseStartTime }}&nbsp;至&nbsp;{{ demand.leaseEndTime }}</div>
            </div>
            <div class="content-right">
              <div class="one">{{ demand.createDate }}</div>
              <div class="two" @click="collect(demand)">
                <i
                  :class="[{iconshoucang:demand.collectionStatus != '1'},{iconshoucang1:demand.collectionStatus == '1'}]"
                  class="iconfont"
                />
                <div>{{ demand.collectionStatus == '1' ?'已收藏':'未收藏' }}</div>
              </div>
              <template v-if="authStatus == '2'">
                <template v-if="demand.inviteUserFlag == '0'">
                  <el-button v-permission="['3-1','3-2']" size="mini" @click="offer(demand)">邀请看仓</el-button>
                </template>
                <template v-else>
                  <el-button v-permission="['3-1','3-2']" style="background-color: #ffffff;color: #be2316;" type="text" size="mini">已邀请</el-button>
                </template>
              </template>
              <el-button plain size="mini" @click="details(demand)">
                详情
                <i :class="{'expand': !demand.hidden}" class="el-icon-d-arrow-right" />
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="!demand.hidden" class="demand-item-details">
          <div class="base-info">
            <div>基本信息</div>
            <div class="info-detail">
              <div class="detail-item">
                <div :title="demand.companyName"><span>公司名称</span> {{ demand.companyName }}</div>
                <div :title="demand.storageLocationLabel"><span>库房位置</span> {{ demand.storageLocationLabel }}</div>
                <div :title="demand.storageTypeLabel"><span>货物类型</span> {{ demand.storageTypeLabel }}</div>
                <div :title="`${demand.demandArea}m²`"><span>需求面积</span> {{ demand.demandArea }}m²</div>
              </div>
              <div class="detail-item">
                <div :title="demand.leaseStartTime"><span>租赁开始日期</span> {{ demand.leaseStartTime }}</div>
                <div :title="demand.leaseEndTime"><span>租赁结束日期</span> {{ demand.leaseEndTime }}</div>
                <div :title="demand.warehouseTypeLabel"><span>仓库类型</span> {{ demand.warehouseTypeLabel }}</div>
                <div :title="`${demand.expectPrice}元/m²/天`"><span>期望租金</span> {{ demand.expectPrice }}元/m²/天</div>
              </div>
              <div class="detail-item">
                <div :title="demand.fireQualificationLabel"><span>消防资质</span> {{ demand.fireQualificationLabel }}</div>
                <div :title="demand.warehouseEquipmentLabel"><span>库内设备</span> {{ demand.warehouseEquipmentLabel }}</div>
                <div :title="demand.floorTextureLabel"><span>地坪质地</span> {{ demand.floorTextureLabel }}</div>
                <div :title="demand.landingPlatformLabel"><span>卸货平台</span> {{ demand.landingPlatformLabel }}</div>
              </div>
            </div>
          </div>
          <div class="contact-info">
            <div>联系人信息</div>
            <ul>
              <li>
                <span>联系人</span> {{ demand.linkMan }}
              </li>
              <li>
                <span>联系电话</span> {{ demand.telephone }}
              </li>
            </ul>
          </div>
          <div class="imgs-info">
            <div>货物照片</div>
            <ul v-if="cargoUrl(demand)" v-viewer>
              <li v-for="(item , ids) in cargoUrl(demand)" :key="ids">
                <el-image class="infoImg" :src="item | getImg" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
              </li>
            </ul>
            <ul v-else v-viewer>
              <li>
                <el-image class="infoImg" :src="require('@/assets/img/default_img.png')" lazy onerror="this.src='https://graph.baidu.com/thumb/v3/3277128572,4129418819.jpg';this.onerror=null;" />
              </li>
            </ul>
            <div>备注</div>
            <span>{{ demand.remarks }}</span>
          </div>
        </div>
      </div>
    </template>
    <div class="demand-items-pagination">
      <el-pagination
        :current-page="pagination.pageNo"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper,total, sizes"
        @current-change="changeCurrent"
        @size-change="changeSize"
      />
    </div>
  </div>
</template>

<script>

import { findPageDemand } from '@/api/cloud/storage-demand-info/components/storageDemandItems'
import { tableClass } from '@/api/cloud/storage-demand-info/components/StorageDemandItemsParam' // 仓储供给信息、表单参数列表
import { mapGetters } from 'vuex'
const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)

export default {
  name: 'StorageDemandItems',
  filters: {
    textFormat(date) {
      console.log(date)
    }
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function() {
    return {
      data: [],
      viewControl: {
        loading: false
      },
      pagination: table.Page
    }
  },
  computed: {
    cargoUrl(demand) { // 图片回调
      return (demand) => {
        if (demand.cargoUrl == null || demand.cargoUrl == '') {
          return false
        }
        return demand.cargoUrl.split(',').filter(n => n) // 数组去空
      }
    },
    ...mapGetters(['userType', 'userInfo', 'authStatus'])
  },
  watch: {
    params: {
      immediate: true, // 在监听开始后立即回调
      handler(val) {
        this.loadData()
      },
      deep: true
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 数字转为货币
    getMoney(num) {
      return Number(200).toLocaleString(undefined, {
        style: 'currency',
        currency: 'CNY'
      })
    },
    // 邀请看仓
    offer(demand) {
      console.log('1111111111111111',demand)
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      if (this.userInfo.isAdmin == '0') {
        this.$router.push({ name: 'QualificationsAuthen' })
        return
      }
      this.$emit('invitation', demand)
    },
    // 收藏
    collect(demand) {
      if (this.userType == '') {
        this.$message({
          type: 'warning',
          message: '请登录！'
        })
        setTimeout(() => {
          this.$router.push({ name: 'Login' })
        }, 200)

        return
      }
      if (this.authStatus != '2') {
        this.$message({
          offset: 100,
          message: '该用户还未资质认证，请先资质认证',
          type: 'warning'
        })
        setTimeout(() => {
          this.$router.push({ name: 'QualificationsAuthen' })
        }, 200)
        return
      }
      this.$emit('favorites', demand)
    },
    // 详情
    details(demand) {
      if (this.userType == '') {
        this.$router.push({ name: 'Login' })
        return
      }
      if (demand.hidden) {
        this.data.map(res => {
          res.hidden = true
          return res
        })
      }
      demand.hidden = !demand.hidden
    },
    // 列表查询
    loadData() {
      this.viewControl.loading = true
      this.params.publishStatus = '2' // 根据发布状态查询
      this.params.myType = false // 根据发布状态查询
      findPageDemand(Object.assign(this.pagination, this.params), this.userType).then(res => {
        this.data = res.result.rows.map(res => {
          res.hidden = true
          res.collectionSubmit = false
          return res
        })
        this.pagination.total = res.result.total
        this.viewControl.loading = false
      }).catch(err => {
        console.log(err)
        this.viewControl.loading = false
      })
    },
    // 分页监听
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 分页监听
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    }
  }
}
</script>
<style lang="scss" scoped>
$perfix: "demand-item";
$main-color: rgb(190, 35, 22);

/deep/.no-data-info {
    background-color: #fff;
    width: 100%;
    text-align: center;
    margin-top: 8px;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
  }
.#{$perfix}-container {
  *::selection {
    background-color: rgba(0,0,0,0) !important;
  }

  width: 100%;
  box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.09);
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  border-radius:4px;
  .demand-demandName{
    color: #be2316;
    font-weight: 600;
  }
  .#{$perfix}-card {
    display: flex;
    padding: 12px;
    border-radius: 4px;
    padding: 12px;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    align-items: center;
    border: 1px solid #ebeef5;
    .#{$perfix}-picture {
      /*width: 225px;*/
      height: 168px;
      // height: 100%;
      display: inline-block;
      >img{
        width: 100%;
        height: 100%;
      }
      &.hidden {
        display: none;
      }
      .el-image {
        height: 168px;
        width: 225px;
        .image-slot {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 14px;
          [class*=" el-icon-"],
          [class^="el-icon-"] {
            font-family: element-icons !important;
            speak: none;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            vertical-align: baseline;
            display: inline-block;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-size: 30px;
          }
        }
      }
    }

    .#{$perfix}-content {
      display: flex;
      padding-left: 24px;
      height: 171px;
      width: 100%;
      justify-content: space-between;
      >div{
        height: 100%;
      }
      .content-left {
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .remarksCls{
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          overflow: hidden;
          // text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          // word-wrap: break-word;
          word-break: break-all;
        }
        span:first-child::after {
          // content: " : ";
        }
        .title {
          color: $main-color;
          font-weight: bold;
          white-space: nowrap;
          height: 24px;
          font-size: 24px;
          margin-bottom: 9px;
          width: 100%;
          i {
            color: initial !important;
            font-weight: initial !important;
            font-size: 1px !important;
            margin: 0 0;
            padding: 0 0;
            width: 24px;
          }
        }
      }
      .content-middle {
        text-align: center;
        font-size: 14px;
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        >* {
          height: 28px;
          &:nth-child(even) {
            margin-bottom: 17px;
          }
          &:first-child {
            margin-top: 10px;
          }
        }
        > div {
          padding: 4px 0px;
          width: 100%;
          &:nth-child(odd) {
            color: #ccc;
          }
        }

        .one {
          color: $main-color;
          strong {
            font-size: 24px;
          }
        }

        .there {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .content-right {
        width: 15%;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-direction: column;
        >*{
         &:first-child {
            margin-top: 10px;
           }
        }
        > div {
          padding: 4px 0px;
        }

        .two {
          display: flex;
          width: 4rem;
          text-align: center;
          cursor: pointer;
          i {
            color: #be2316;
          }
        }
        /deep/ .el-button {
          background-color: #be2316;
          color: white;
          border-color: #be2316;
        }

        /deep/ .el-button.is-plain {
          background-color: white;
          color: #be2316;
          border-color: #be2316;
          padding: 7px 4px !important;
          width: 56px;
          span > i {
            transition: 1s all;
            transform: rotateZ(90deg);
            &.expand {
              transform: rotateZ(-90deg);
            }
          }
        }
      }
    }
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .#{$perfix}-details {
    width: 100%;
    background-color: rgb(250, 251, 255);
    transition: all 0.8s ease-in-out;
    z-index: -1;
    padding-bottom: 16px;
    display: block;
    animation: show 0.8s ease-in-out;
    clip: rect(0 auto 0 0);
    > div {
      padding: 16px 16px;
      width: calc(100% - 32px);
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none !important;
      }

      ul {
        li {
          span:after {
            content: " : ";
          }
        }
      }

      > div {
        font-size: 15px;
        font-weight: bold;
        color: $main-color;
        margin-bottom: 24px;
      }
      &.base-info {
        span:after {
          content: " : ";
        }
        .info-detail{
          display: flex;
          flex-direction: column;
          color: #000000;
          font-weight: normal;
          margin-bottom: 0;
          .detail-item{
            display: flex;
            margin-bottom: 24px;
            div{
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 10px;
              &:nth-child(1){
                width: 30%;
              }
              &:nth-child(2){
                width: 30%;
              }
              &:nth-child(3){
                width: 20%;
              }
              &:nth-child(4){
                width: 20%;
              }
            }
          }
        }
      }
      &.contact-info {
        ul {
          width: 50%;
          columns: 2;
          column-width: 25%;
          column-gap: 16px;
          > li {
            height: 16px;
            line-height: 16px;
            padding: 4px 0px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }

      &.imgs-info {
        // word-wrap: break-word;
        word-break: break-all;
        ul {
          display: inline-block;
          li {
            float: left;
            margin-right: 24px;
            margin-bottom: 12px;
            &:last-child {
              margin-right: 0px !important;
            }
            .infoImg {
              height: 124px;
              width: 136px;
            }
          }
        }
      }
    }
  }
}

.demand-items-pagination{
  width: 100%;
  margin-top: 24px;
}
  .el-button--mini{
    width: 80px!important;
  }
</style>

